import { useRef } from 'react';
import Boto from 'components/3catinfo/Boto';
import clsx from 'clsx';
import styles from './videoBase.module.scss';

export default function VideoBase(props) {
    const { playerVideoTagId, fixed, handlerCloseFlotant } = props;

    const stylesTancarFlotant = clsx({
        [styles.tancarFlotant]: true,
        [styles.show]: fixed
    });

    const stylesVideoBase = clsx({
        'videoviewbase': true,
        'fixed-player': fixed
    });

    const videoBaseRef = useRef();
    const botoTancarRef = useRef();

    const handleKeyDownBotoTanca = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            document.querySelector('.bmpui-ui-hugeplaybacktogglebutton').focus();
        }
        if (event.shiftKey && event.key === 'Tab') {
            event.preventDefault();
            if (playerVideoTagId.includes('video')) {
                document.querySelector('.bmpui-ui-fullscreentogglebutton').focus();
            }
            if (playerVideoTagId.includes('audio')) {
                if (playerVideoTagId.includes('audio-tts')) {
                    document.querySelector('.bmpui-ui-popupbutton').focus();
                } else {
                    document.querySelector('.bmpui-ui-volumeslider').focus();
                }
            }
        }
    };

    const handleVideoKeyDown = (e) => {
        if (e.shiftKey && e.key === 'Tab') {
            const target = e.target;
            if (target.getAttribute('class').includes('hugeplaybacktogglebutton')) {
                e.preventDefault();
                botoTancarRef.current.focus();
            }
        }
    };

    return (
        <>
            <div
                className={stylesVideoBase}
                id={'videoviewbase_' + playerVideoTagId}
                ref={videoBaseRef}
                onKeyDown={handleVideoKeyDown}
            >
                <div className='videowrapper'>
                    <div>
                        <video
                            poster='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
                            width='100%'
                            height='100%'
                            className='meplayer'
                            id={playerVideoTagId}
                        ></video>
                        <div className={stylesTancarFlotant}>
                            <Boto
                                ref={botoTancarRef}
                                tag='button'
                                estil='noEstil'
                                className={styles.botoTancar}
                                icona='tanca'
                                isIconaBlanc={true}
                                altIcona='Tanca'
                                onClick={handlerCloseFlotant}
                                onKeyDown={handleKeyDownBotoTanca}
                            />
                        </div>
                    </div>
                </div>
                <div className='poster'></div>
            </div>
            {/* <div className='R-dvrmsg fade'>MOU-TE PER LA BARRA PER TIRAR ENRERE</div> */}
            <div className='ratiokeeper'></div>
        </>
    );
}
